'use strict';

import offset from 'offset';

(
    function($)
    {
        $.fn.film = function(params)
        {
            $(this).each
            (
                function()
                {
                    function toSet()
                    {
                        if($(window).width() >= 800)
                        {
                            params?.blocks?.each(function(index)
                            {
                                const position = offset($(this).get(0));

                                if($(window).scrollTop() >= (position.top - $(this).height() / 3) && $(window).scrollTop() <= (position.top + $(this).height() / 4))
                                {
                                    params.blocks.removeClass("film__block--current");
                                    $(this).addClass("film__block--current");

                                    const $image = params?.images?.filter(":eq(" + index + ")");

                                    if(!$image.hasClass("film__image--current"))
                                    {
                                        params?.images?.removeClass("film__image--current");
                                        $image.addClass("film__image--current");
                                    }
                                }
                            });
                        }
                    }

                    $(window).on("scroll",
                        function()
                        {
                            toSet();
                        }
                    );

                    toSet();

                    for(let i = 0; i < 5; i++)
                    {
                        window.setTimeout(function()
                        {
                            toSet();
                        }, 500 * i);
                    }
                }
            );
        }
    }
)(jQuery);
